import Proj1 from '../assets/proj1.jpg'
import Proj2 from '../assets/proj2.jpg';
import Proj3 from '../assets/proj3.webp';
import Proj4 from '../assets/proj4.webp';

export const ProjectItem =[
    {
        name: 'Simple React Website',
        image: Proj1,
        skills: 'React, HTML, CSS, MeterialUI'
    },

    {
        name: 'Blog Website',
        image: Proj4,
        skills: 'React, HTML, CSS, MaterialUI, Firebase'
    },


    {
        name: 'Portfolio',
        image: Proj3,
        skills: 'React, HTML, CSS, MaterialUI'
    },

    {
        name: 'Ecommerce Website',
        image: Proj2,
        skills: 'React, HTML, CSS, MaterialUI'
    },

    {
        name: 'Portfolio',
        image: Proj3,
        skills: 'ChatGPT'
    },

]